var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStoreFill0Wght200Grad0Opsz40(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 40,
    viewBox: "0 -960 960 960",
    width: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#99cc99",
    d: "M176.923-746.154V-780h606.975v33.846H176.923ZM181.795-180v-245.333h-52.154v-33.847L176.923-660h606.308l47.795 200.82v33.847h-52.154V-180h-33.846v-245.333H535.949V-180H181.795Zm33.846-33.846h286.462v-211.487H215.641v211.487ZM162.974-459.18H797.18 162.974Zm0 0H797.18L758-626.154H202.154l-39.18 166.974Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoreFill0Wght200Grad0Opsz40);
export default __webpack_public_path__ + "static/media/store_FILL0_wght200_GRAD0_opsz40.2dc049797c7755fc746c89e21e0aa28a.svg";
export { ForwardRef as ReactComponent };